import axios from 'axios'

// Plain axios (NOT the shared `instanceAxios`) on purpose: resolve-tenant is
// called from the login page before any Keycloak token exists, and
// instanceAxios's request interceptor would otherwise treat "no token yet"
// as an expired session and show the session-expired banner.
const plainApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
})

export interface ResolvedTenant {
  keycloakRealm: string
  keycloakClientId: string
  organizationName?: string
}

export const resolveTenantApi = async (slug?: string): Promise<ResolvedTenant> => {
  const response = await plainApi.post<ResolvedTenant>('/auth/resolve-tenant', { slug })
  return response.data
}
